var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{class:_vm.$classes(),style:(_vm.genericStyles()),attrs:{"value":true,"color":_vm.color,"outlined":!_vm.$classes().includes('frameless')}},[_c('common-message',{attrs:{"spec":_vm.spec}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }